module.exports = __webpack_public_path__ + "img/avatar6.1c1008fc.png";